export default (number, currencyType = '$') => {
  const cleanedNumber = number.toString().replace(/[^0-9.]/g, '');
  const parsedNumber = isNaN(cleanedNumber) ? 0 : parseFloat(number);
  const fixedNumber = parsedNumber.toFixed(2);
  return currencyType + fixedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
